export const recDetailModel = (id) => ({
    id: id,
    dtId: null,
    recId: null,
    line: null,
    itemId: null,
    itemCode: null,
    itemName: null,
    itemQty: null,
    itemUnit: null,
    itemPriceUnit: null,
    itemDiscount: null,
    itemDisType: null,
    itemTotal: null,
    itemGroup: null,
    itemRecBalance: null,
    itemStatus: null,
    whId: null,
    zoneId: null,
    ltId: null,
    dsSeq: null
});